import { apiSlice } from './apiSlice'
import type { Case } from './casesApi'

export interface Team {
  id: string
  name: string
  university: string
  members: string[]
  manager_id?: string
  coach_id?: string
  status: string
  assigned_cases?: string[]
  created_at?: string
  updated_at?: string
}

export interface TeamCreate {
  name: string
  university: string
  members: string[]
  coach_id?: string
}

export const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query<Team[], void>({
      query: () => '/teams',
      providesTags: ['Team'],
    }),
    getTeam: builder.query<Team, string>({
      query: (id) => `/teams/${id}`,
      providesTags: (result, error, id) => [{ type: 'Team', id }],
    }),
    createTeam: builder.mutation<Team, TeamCreate>({
      query: (body) => ({
        url: '/teams',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Team'],
    }),
    updateTeam: builder.mutation<Team, { id: string } & Partial<TeamCreate>>({
      query: ({ id, ...data }) => ({
        url: `/teams/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Team', id }],
    }),
    getTeamCases: builder.query<Case[], string>({
      query: (teamId) => `/teams/${teamId}/cases`,
      providesTags: (result, error, teamId) => [{ type: 'Case', id: `team-${teamId}` }],
    }),
  }),
})

export const {
  useGetTeamsQuery,
  useGetTeamQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useGetTeamCasesQuery,
} = teamsApi
